// extracted by mini-css-extract-plugin
export var container = "Section-module--container--VlerQ";
export var largeSpacing = "Section-module--largeSpacing--BmcSD";
export var noSpacing = "Section-module--noSpacing--SsH0P";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var section = "Section-module--section--p4Sk3";
export var sectionBg = "Section-module--sectionBg--0UbgK";
export var smallSpacing = "Section-module--smallSpacing--c2-A+";